import { render, staticRenderFns } from "./UpsellTree.vue?vue&type=template&id=ee772752&scoped=true&"
import script from "./UpsellTree.vue?vue&type=script&lang=js&"
export * from "./UpsellTree.vue?vue&type=script&lang=js&"
import style0 from "./UpsellTree.vue?vue&type=style&index=0&id=ee772752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee772752",
  null
  
)

export default component.exports